import { FormType } from '../../interfaces/form.interface';
import { ReactiveFormSubmitDuplicateErrorDetector } from './reactive-form-submit-duplicate-error-detector';

export interface ReactiveFormSubmitErrorPolicyOptions {
  readonly error: unknown;
  readonly formType: FormType;
  readonly hasClientExistsError: boolean;
}

export interface ReactiveFormSubmitErrorPresentation {
  readonly title: string;
  readonly summary: string;
  readonly isDuplicate: boolean;
}

const GENERIC_REQUEST_ERROR_TITLE = 'No hemos podido guardar el registro.';
const GENERIC_REQUEST_ERROR_SUMMARY =
  'La petición ha fallado y el registro no se ha podido guardar. Revisa los datos e inténtalo de nuevo. ' +
  'Si el problema continúa, contacta con soporte.';
const GENERIC_DELETE_ERROR_TITLE = 'No hemos podido borrar el registro.';
const GENERIC_DELETE_ERROR_SUMMARY =
  'La petición ha fallado y el registro no se ha podido borrar. Inténtalo de nuevo. ' +
  'Si el problema continúa, contacta con soporte.';
const DUPLICATE_RECORD_ERROR_TITLE = 'El registro ya existe.';
const DUPLICATE_RECORD_ERROR_SUMMARY =
  'Ya existe un registro con esos datos. Revisa los campos identificativos antes de guardar.';

/** Resolves user-facing submit request errors while keeping request execution elsewhere. */
export class ReactiveFormSubmitErrorPolicy {
  private readonly duplicateErrorDetector = new ReactiveFormSubmitDuplicateErrorDetector();

  public get duplicateTitle(): string {
    return DUPLICATE_RECORD_ERROR_TITLE;
  }

  public resolve(
    options: ReactiveFormSubmitErrorPolicyOptions,
  ): ReactiveFormSubmitErrorPresentation {
    if (
      this.duplicateErrorDetector.isDuplicateError({
        error: options.error,
        hasClientExistsError: options.hasClientExistsError,
      })
    ) {
      return {
        title: DUPLICATE_RECORD_ERROR_TITLE,
        summary: DUPLICATE_RECORD_ERROR_SUMMARY,
        isDuplicate: true,
      };
    }

    if (options.formType === FormType.DELETION) {
      return {
        title: GENERIC_DELETE_ERROR_TITLE,
        summary: GENERIC_DELETE_ERROR_SUMMARY,
        isDuplicate: false,
      };
    }

    return {
      title: GENERIC_REQUEST_ERROR_TITLE,
      summary: GENERIC_REQUEST_ERROR_SUMMARY,
      isDuplicate: false,
    };
  }
}
